import { createSlice } from "@reduxjs/toolkit";

const initialOrganizationFileState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  organizationFileForEdit: undefined,
  organizationForEdit: undefined,
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const organizationFileSlice = createSlice({
  name: "organizationFile",
  initialState: initialOrganizationFileState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getOrganizationFileById
    organizationFileFetched: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.organizationFileForEdit = action.payload.organizationFileForEdit;
    },
    // getOrganizationFileById
    organizationFetched: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.organizationForEdit = action.payload.organizationForEdit;
    },
    // findOrganizationFile
    organizationFilesFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    organizationFileReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    }
  }
});
